import portrait from './consumer/portrait';
import square from './consumer/square';
import landscape from './consumer/landscape';
import init from './cover_template.json';

export default {
  portrait,
  square,
  landscape,
  init,
};



// WEBPACK FOOTER //
// ./src/config/templates/covers/consumer.jsx